import React from 'react';
import iconStar from '../../assets/icon-star-solar.svg';
import iconFolder from '../../assets/icon-add-folder.svg';
import Button from '../Button';
import { RiMenuFold2Line } from 'react-icons/ri';
import { StyledHeader } from './ChatHeader.styles';

const ChatHeader = () => {
  return (
    <>
      <StyledHeader>
        <strong className="heading">UI Design Inspiration</strong>
        <div className="btn-wrap">
          <button type="button" className="btn-info">
            <img src={iconStar} width="24" alt="img" />
          </button>
          <button className="btn-info">
            <img src={iconFolder} width="24" alt="img" />
          </button>
          <Button width="120px">Upgrade</Button>
          <Button variant="secondary" width="120px">
            Share
          </Button>
          <Button variant="secondary" className="btn-more">
            <RiMenuFold2Line size="20" />
          </Button>
        </div>
      </StyledHeader>
    </>
  );
};

export default ChatHeader;
